const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.UpcomingRaceEntryServiceSimpleClient =
  function UpcomingRaceEntryServiceSimpleClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listUpcomingRaceEntries = this.listUpcomingRaceEntries.bind(this);
    this.getUpcomingRaceEntry = this.getUpcomingRaceEntry.bind(this);
    this.requireUpcomingRaceEntryExam =
      this.requireUpcomingRaceEntryExam.bind(this);
    this.bulkAssignUpcomingRaceEntryExams =
      this.bulkAssignUpcomingRaceEntryExams.bind(this);
    this.unassignUpcomingRaceEntryExam =
      this.unassignUpcomingRaceEntryExam.bind(this);
    this.quickPassUpcomingRaceEntry =
      this.quickPassUpcomingRaceEntry.bind(this);
    this.revertQuickPassUpcomingRaceEntryExam =
      this.revertQuickPassUpcomingRaceEntryExam.bind(this);
    this.bulkRequireAndAssignUpcomingRaceEntryRaceDayExams =
      this.bulkRequireAndAssignUpcomingRaceEntryRaceDayExams.bind(this);
    this.unassignUpcomingRaceEntryRaceDayExam =
      this.unassignUpcomingRaceEntryRaceDayExam.bind(this);
    this.setUpcomingRaceEntryExamNote =
      this.setUpcomingRaceEntryExamNote.bind(this);
    this.resetUpcomingRaceEntryExamNote =
      this.resetUpcomingRaceEntryExamNote.bind(this);
    this.setUpcomingRaceEntryFlag = this.setUpcomingRaceEntryFlag.bind(this);
    this.resetUpcomingRaceEntryFlag =
      this.resetUpcomingRaceEntryFlag.bind(this);
  };
const methodInfo_UpcomingRaceEntryService_ListUpcomingRaceEntries =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ListUpcomingRaceEntries",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest,
    imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.listUpcomingRaceEntries =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ListUpcomingRaceEntries",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_ListUpcomingRaceEntries
    );
  };
const methodInfo_UpcomingRaceEntryService_GetUpcomingRaceEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/GetUpcomingRaceEntry",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.getUpcomingRaceEntry =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetUpcomingRaceEntryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/GetUpcomingRaceEntry",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_GetUpcomingRaceEntry
    );
  };
const methodInfo_UpcomingRaceEntryService_RequireUpcomingRaceEntryExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RequireUpcomingRaceEntryExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.requireUpcomingRaceEntryExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.RequireUpcomingRaceEntryExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RequireUpcomingRaceEntryExam",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_RequireUpcomingRaceEntryExam
    );
  };
const methodInfo_UpcomingRaceEntryService_BulkAssignUpcomingRaceEntryExams =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkAssignUpcomingRaceEntryExams",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest,
    imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.bulkAssignUpcomingRaceEntryExams =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.BulkAssignUpcomingRaceEntryExamsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkAssignUpcomingRaceEntryExams",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_BulkAssignUpcomingRaceEntryExams
    );
  };
const methodInfo_UpcomingRaceEntryService_UnassignUpcomingRaceEntryExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.unassignUpcomingRaceEntryExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryExam",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_UnassignUpcomingRaceEntryExam
    );
  };
const methodInfo_UpcomingRaceEntryService_QuickPassUpcomingRaceEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/QuickPassUpcomingRaceEntry",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.quickPassUpcomingRaceEntry =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.QuickPassUpcomingRaceEntryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/QuickPassUpcomingRaceEntry",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_QuickPassUpcomingRaceEntry
    );
  };
const methodInfo_UpcomingRaceEntryService_RevertQuickPassUpcomingRaceEntryExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RevertQuickPassUpcomingRaceEntryExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.revertQuickPassUpcomingRaceEntryExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.RevertQuickPassUpcomingRaceEntryExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/RevertQuickPassUpcomingRaceEntryExam",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_RevertQuickPassUpcomingRaceEntryExam
    );
  };
const methodInfo_UpcomingRaceEntryService_BulkRequireAndAssignUpcomingRaceEntryRaceDayExams =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkRequireAndAssignUpcomingRaceEntryRaceDayExams",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest,
    imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListUpcomingRaceEntriesResponse.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.bulkRequireAndAssignUpcomingRaceEntryRaceDayExams =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.BulkRequireAndAssignUpcomingRaceEntryRaceDayExamsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/BulkRequireAndAssignUpcomingRaceEntryRaceDayExams",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_BulkRequireAndAssignUpcomingRaceEntryRaceDayExams
    );
  };
const methodInfo_UpcomingRaceEntryService_UnassignUpcomingRaceEntryRaceDayExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryRaceDayExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.unassignUpcomingRaceEntryRaceDayExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UnassignUpcomingRaceEntryRaceDayExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/UnassignUpcomingRaceEntryRaceDayExam",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_UnassignUpcomingRaceEntryRaceDayExam
    );
  };
const methodInfo_UpcomingRaceEntryService_SetUpcomingRaceEntryExamNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryExamNote",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.setUpcomingRaceEntryExamNote =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetUpcomingRaceEntryExamNoteRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryExamNote",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_SetUpcomingRaceEntryExamNote
    );
  };
const methodInfo_UpcomingRaceEntryService_ResetUpcomingRaceEntryExamNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryExamNote",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.resetUpcomingRaceEntryExamNote =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryExamNoteRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryExamNote",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_ResetUpcomingRaceEntryExamNote
    );
  };
const methodInfo_UpcomingRaceEntryService_SetUpcomingRaceEntryFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryFlag",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.setUpcomingRaceEntryFlag =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetUpcomingRaceEntryFlagRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/SetUpcomingRaceEntryFlag",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_SetUpcomingRaceEntryFlag
    );
  };
const methodInfo_UpcomingRaceEntryService_ResetUpcomingRaceEntryFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryFlag",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest,
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UpcomingRaceEntry.decode
  );
module.exports.UpcomingRaceEntryServiceSimpleClient.prototype.resetUpcomingRaceEntryFlag =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ResetUpcomingRaceEntryFlagRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UpcomingRaceEntryService/ResetUpcomingRaceEntryFlag",
      message,
      metadata || {},
      methodInfo_UpcomingRaceEntryService_ResetUpcomingRaceEntryFlag
    );
  };
